import { portalFetch } from "@/lib/portalApi";

export interface SocialLinks {
  website?: string;
  linkedin?: string;
  twitter?: string;
  facebook?: string;
  instagram?: string;
  youtube?: string;
}

export interface OrgBrandProfile {
  company_name?: string;
  brand_name?: string;
  tagline?: string;
  value_proposition?: string;
  key_differentiators?: string[];
  brand_voice?: string;
  tone_attributes?: string[];
  key_messages?: string[];
  boilerplate?: string;
  industry_expertise?: string[];
  avoid_terms?: string[];
  // Default social URLs for partner fallback. When a partner record has no
  // value for a given social channel, the campaign worker resolves it from
  // here at brand-profile build time. Per-channel: a partner can override
  // X but inherit LinkedIn from the org. Note: contact fields (email,
  // phone, website, address, boilerplate) are intentionally NOT in this
  // fallback chain — vendor-self partners render those blank by design.
  social_links?: SocialLinks;
}

export interface OrgBrandProfileResponse {
  organisation_id: string;
  brand_profile: OrgBrandProfile | null;
}

export const brandApi = {
  getOrgBrandProfile: (token: string, orgId: string) =>
    portalFetch<OrgBrandProfileResponse>(
      `/api/v1/brand/organisations/${orgId}/brand-profile`,
      { token },
    ),

  updateOrgBrandProfile: (
    token: string,
    orgId: string,
    data: Partial<OrgBrandProfile>,
  ) =>
    portalFetch<OrgBrandProfileResponse>(
      `/api/v1/brand/organisations/${orgId}/brand-profile`,
      { token, method: "PUT", body: data },
    ),
};
